<div class="container-fluid">
  <app-content-tab-list activeTab="2" type="user" category="User Management"></app-content-tab-list>
  <div class="row section1 justify-content-between mt-4">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">Quotes ({{total}})</h5>
        <p class="home-subtitle">Add new fun-words & quotes</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <div class="dashboard-btn dashboard-manage">
        <div><a routerLink="/quotes/add-quote">
          <button class="btn btn-primary btn-dashboard"><i class="las la-quote-left"></i>Create new quote</button>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="row section1">
  <div class="col-12">
    <div class="quotes-filters-card">
      <div class="quotes-filters-title">Filter Quotes</div>
      <div class="quotes-filters-grid">
        <div class="quotes-filter-item quotes-filter-item-wide">
          <label class="quotes-filter-label">Keyword</label>
          <input type="text"
            class="form-control"
            [(ngModel)]="filters.keyword"
            (keydown)="handleFilterInputKeyDown($event)"
            placeholder="Quote text"/>
        </div>
        <div class="quotes-filter-item">
          <label class="quotes-filter-label">Status</label>
          <select class="form-control" [(ngModel)]="filters.status">
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div class="quotes-filter-item">
          <label class="quotes-filter-label">Type</label>
          <select class="form-control" [(ngModel)]="filters.type">
            <option value="all">All</option>
            <option value="Entity">Entity</option>
            <option value="Bhakt">Bhakt</option>
            <option value="Vishwaguru">Vishwaguru</option>
          </select>
        </div>
        <div class="quotes-filter-item">
          <label class="quotes-filter-label">Sort By</label>
          <select class="form-control" [(ngModel)]="filters.sortBy">
            <option value="created_desc">Latest created</option>
            <option value="created_asc">Oldest created</option>
          </select>
        </div>
        <div class="quotes-filter-actions">
          <button class="btn quotes-filter-apply-btn ml-0" (click)="applyFilters()">Apply Filters</button>
          @if (hasActiveFilters()) {
            <button class="btn btn-outline-secondary ml-2" (click)="clearFilters()">Reset</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row section1">
  <div class="col-12">
    <div class="table-responsive applicants-details overflow-x-visible">
      <table class="table table-bordered user-table">
        <thead>
          <tr>
            <th scope="col">Quote By</th>
            <th scope="col">Quote</th>
            <th scope="col">Status</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        @if ((quotes?.length || 0) > 0 && !loading) {
          <tbody>
            @for (q of quotes | paginate: { itemsPerPage: 10, currentPage: page, totalItems: total, id:'quotes'}; track q; let qi = $index) {
              <tr class="client">
                <td>{{q.quoteBy?.name}}</td>
                <td>{{q.famous_quote}}</td>
                <td>{{q.status | uppercase}}</td>
                <td>{{q.createdAt | date:'medium' }}</td>
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <a class="   mr-3 text-primary py-2 text-nowrap">
                        View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                        @if (q.status == 'pending') {
                          <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap"
                            (click)="updateQuoteStatus(q.id, 'approved')">
                            <i class="las la-check mb-1 la-lg   align-middle mr-0"></i> Approve</a>
                          }
                          @if (q.status == 'pending') {
                            <a  class=" dropdown-item  text-info border-bottom py-2 text-nowrap"
                              (click)="updateQuoteStatus(q.id, 'rejected')">
                              <i class="las la-times mb-1 la-lg  align-middle mr-0"></i> Reject</a>
                            }
                            @if (q.status != 'pending') {
                              <a class=" dropdown-item  text-danger py-2 text-nowrap "
                                (click)="deleteQuote(q.id)">
                                <i class="las la-trash mb-1 la-lg  align-middle mr-0"></i> Delete</a>
                              }
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
                @if (loading) {
                  <tbody>
                    @for (q of loaders; track q; let qi = $index) {
                      <tr class="client">
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
            @if (!loading && !quotes?.length) {
              <div class="d-flex align-items-center justify-content-center py-5">
                No quotes found
              </div>
            }
            <div class="float-right mt-3">
              <pagination-controls (pageChange)="pageChange($event)" id="quotes"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
